var _defs, _polygon, _path, _rect, _path2, _path3, _ellipse, _rect2, _ellipse2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon2, _rect3, _ellipse3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1403 986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#114b5f;}.cls-2{fill:#d4d5dd;}.cls-3{fill:#a5a0a0;}.cls-4{fill:#d1cbcb;}.cls-5{fill:#607e92;}.cls-6{fill:#505b7f;}.cls-7{fill:#c2cd23;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1374 102.12 1014.56 23 1173.48 140.21 1193.18 166.56 1206.9 368.59 1374 102.12"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.8,539.6C72.92,658.4,327.65,923.71,327.65,923.71L1055.9,258.57c3.46-3.21,86.93-55.25,91.32-57.23l199.92-90.71-310.41,49.06c-12.91,1.43-37.49,10.69-47.91,18L327.65,681,54.37,413.73c-5.58-4.46-14.19-.74-14.19,6.15V534.69A18.52,18.52,0,0,0,40.8,539.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 358.29,
    y: 782.94,
    width: 306.63,
    height: 35.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M511.6,908.77c-76.5,0-139.73-52.61-151.26-121.34a135.56,135.56,0,0,0-2,22.47c0,79.43,68.64,143.82,153.31,143.82S664.92,889.33,664.92,809.9a135.56,135.56,0,0,0-2.06-22.47C651.34,856.16,588.11,908.77,511.6,908.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M511.6,917.76c76.51,0,139.74-52.62,151.26-121.34A135.56,135.56,0,0,0,664.92,774c0-79.43-68.64-143.82-153.32-143.82S358.29,694.52,358.29,774a135.56,135.56,0,0,0,2,22.47C371.87,865.14,435.1,917.76,511.6,917.76Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 511.6,
    cy: 773.95,
    rx: 153.32,
    ry: 17.98
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 358.29,
    y: 773.95,
    width: 306.63,
    height: 8.99
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 511.6,
    cy: 782.94,
    rx: 153.32,
    ry: 8.99
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M890.46,668.54H711.84a.36.36,0,0,0-.36.35v176c0,52.09,38.88,95.21,89.64,103A108.55,108.55,0,0,0,822.25,949c57.19-2.48,101.18-51.08,101.18-107.38V668.89a.36.36,0,0,0-.36-.35H890.46Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M923.43,484.15c0-57.56-47.45-104.22-106-104.22a106.92,106.92,0,0,0-16.31,1.36c-50.76,7.73-89.67,50.76-89.67,102.86V668.54H923.43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M744.09,844.91v-176a.36.36,0,0,1,.36-.35H711.84a.36.36,0,0,0-.36.35v176c0,59.13,50.06,106.75,110.77,104.12a105.31,105.31,0,0,0,11.47-1.17C783,940.12,744.09,897,744.09,844.91Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M744.09,484.15c0-52.1,38.9-95.13,89.67-102.86a106.9,106.9,0,0,0-16.3-1.36c-58.53,0-106,46.66-106,104.22V668.54h32.61Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1171.81,310.82V661.13a53.37,53.37,0,0,1-12.44,9.93c-17,10.27-43.54,16.83-73.32,16.83s-56.27-6.56-73.32-16.83a53.58,53.58,0,0,1-12.44-9.93V310.82h3.21c15.51,14,46.68,23.57,82.55,23.57s67-9.56,82.55-23.57Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1070.46,716.43h27.29V731.2c-4.49.31-9.13.46-13.88.46-4.49,0-8.89-.15-13.18-.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1113.34,689.73v39.8c-5,.76-10.18,1.33-15.59,1.67V716.43h-27.29l.23,14.81c-5.46-.34-10.76-.87-15.83-1.64V689.81a205.6,205.6,0,0,0,58.48-.08Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1178,684.88V685h-3s.12-.07.16-.11Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1097.75 716.43 1097.75 883.99 1074.36 952.54 1070.69 731.24 1070.46 716.43 1097.75 716.43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1070.46,
    y: 228.97,
    width: 35.09,
    height: 68.55
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1086.05,
    cy: 223.26,
    rx: 89.66,
    ry: 24.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1051.55,686.69c-15.4-2.86-28.77-7.66-38.83-13.71a52.8,52.8,0,0,1-12.43-9.91V312.75h3.19c7.45,6.7,18.44,12.42,31.89,16.53V674.5a53,53,0,0,0,12.17,9.9C1048.82,685.2,1050.15,686,1051.55,686.69Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1084.22,360.9v20.4c-22.14,0-42.49-2.84-58.47-7.63v-20.4C1041.73,358,1062.08,360.9,1084.22,360.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1084.22,413.25v20.4c-22.14,0-42.49-2.84-58.47-7.63v-20.4C1041.73,410.38,1062.08,413.25,1084.22,413.25Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1084.22,462.09v20.4c-22.14,0-42.49-2.84-58.47-7.63v-20.4C1041.73,459.21,1062.08,462.09,1084.22,462.09Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1084.22,515.4v20.4c-22.14,0-42.49-2.84-58.47-7.63v-20.4C1041.73,512.53,1062.08,515.4,1084.22,515.4Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1084.22,568.72v20.4c-22.14,0-42.49-2.84-58.47-7.63v-20.4C1041.73,565.85,1062.08,568.72,1084.22,568.72Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1084.22,625.84v20.4c-22.14,0-42.49-2.84-58.47-7.63v-20.4C1041.73,623,1062.08,625.84,1084.22,625.84Z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1086.05,
    cy: 308.94,
    rx: 120.85,
    ry: 30.47
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4d8ef6898e6effc86463dedea9708fed.svg";
export { ForwardRef as ReactComponent };